export default __webpack_public_path__ + "static/media/green-gradient-blue.29d8268f.png";